import React from 'react';

const EyeClosedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="27"
    height="25"
    viewBox="0 0 27 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.70999 1L25.2895 24M10.6758 9.8341C9.99116 10.524 9.56983 11.464 9.56983 12.5C9.56983 14.6172 11.3294 16.3333 13.4997 16.3333C14.5772 16.3333 15.5534 15.9104 16.2632 15.2255M6.2949 5.66025C3.80686 7.26155 1.91177 9.66837 1 12.5C2.66923 17.6841 7.63443 21.4444 13.5 21.4444C16.1054 21.4444 18.5332 20.7026 20.5733 19.4235M12.1897 3.61866C12.6207 3.57693 13.0579 3.55556 13.5 3.55556C19.3656 3.55556 24.3308 7.31594 26 12.5C25.6323 13.6423 25.1044 14.7154 24.4422 15.6944"
      stroke="#B3DCFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeClosedIcon;
